// 区域分类 i18n 目录（PRD §4.9）— zh-CN。
// 译自 pt-BR 源文件（MG 法令附件 + IGAM 条例）。
export const regionalClassificationCatalogZhCN = {
  "norms": {
    "mgIndustry": "MG 第 48.140/2021 号法令 - 用于处置工业废料或尾矿的坝",
    "mgMining": "MG 第 48.140/2021 号法令 - 用于处置采矿废料或尾矿的坝",
    "mgWater": "MG 第 48.140/2021 号法令 - 用于蓄水、与工业或采矿过程相关的坝",
    "igam": "IGAM"
  },
  "mgIndustry": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - 风险分类" },
      "pda": { "label": "PDA", "subtitle": "2 - 潜在环境损害" }
    },
    "grades": {
      "ct": "1.1 - 技术特性 - CT",
      "ec": "1.2 - 保养状态 - EC",
      "psb": "1.3 - 大坝安全计划 - PSB",
      "pda": "2 - 按潜在环境损害分类 - PDA"
    },
    "columns": {
      "ctA": "高度",
      "ctB": "长度",
      "ctC": "设计流量",
      "ctD": "施工方法",
      "ctE": "监测仪器",
      "ecF": "溢洪结构可靠性",
      "ecG": "渗流",
      "ecH": "变形与沉降",
      "ecI": "坡面/护面的劣化",
      "psbJ": "项目文档",
      "psbK": "大坝安全团队专业人员的组织结构与资质",
      "psbL": "安全检查与监测程序手册",
      "psbM": "应急行动计划 – PAE（监管机构要求时）",
      "psbN": "仪器检查与监测报告及安全分析",
      "pdaA": "水库总库容",
      "pdaB": "下游是否存在人口",
      "pdaC": "环境影响",
      "pdaD": "社会经济影响"
    },
    "options": {
      "ctA": {
        "score0": "高度 ≤ 10m",
        "score1": "10m < 高度 < 30m",
        "score4": "30m ≤ 高度 ≤ 60m",
        "score7": "高度 > 60m"
      },
      "ctB": {
        "score0": "长度 ≤ 50m",
        "score1": "50m < 长度 < 200m",
        "score2": "200 ≤ 长度 ≤ 600m",
        "score3": "长度 > 600m"
      },
      "ctC": {
        "score0": "可能最大洪水（CMP）或万年一遇",
        "score2": "千年一遇",
        "score5": "重现期 = 500 年",
        "score10": "重现期低于 500 年或未知 / 研究不可靠"
      },
      "ctD": {
        "score1": "单一阶段",
        "score3": "加高结构"
      },
      "ctE": {
        "score0": "存在符合技术项目的仪器，或不适用监测方法",
        "score2": "存在与项目不符的仪器，但正在安装仪器以符合项目要求",
        "score6": "存在与项目不符的仪器，且未安装仪器以符合项目要求",
        "score8": "大坝未安装仪器，与项目不符"
      },
      "ecF": {
        "score0": "土建结构保养良好且正常运行 / 大坝无需溢洪结构",
        "score3": "结构存在已识别问题且正在实施纠正措施",
        "score6": "结构存在已识别问题且未实施必要的纠正措施",
        "score10": "结构存在已识别问题，溢洪能力下降且无纠正措施"
      },
      "ecG": {
        "score0": "渗流由排水系统完全控制",
        "score3": "下游区域、护面、坡面和坝肩出现潮湿或渗水，但稳定且受监测",
        "score6": "下游区域、护面、坡面或坝肩出现潮湿或渗水，未实施必要的纠正措施",
        "score10": "下游区域出现渗水并带出材料或流量增大或所含材料发生渗透，可能危及结构安全"
      },
      "ecH": {
        "score0": "不存在可能危及结构安全的变形与沉降",
        "score2": "存在裂缝和沉陷，正在实施纠正措施",
        "score6": "存在裂缝和沉陷，未实施必要的纠正措施",
        "score10": "存在裂缝、沉陷或滑动，可能危及结构安全"
      },
      "ecI": {
        "score0": "坡面与护面无劣化",
        "score2": "坡面与护面防护失效，存在灌木植被",
        "score6": "表面侵蚀、钢筋外露、存在乔木植被，未实施必要的纠正措施",
        "score10": "坡面出现明显凹陷、滑动、深侵蚀沟，可能危及结构安全"
      },
      "psbJ": {
        "score0": "施工图项目及\"竣工\"项目",
        "score2": "施工图项目或\"竣工\"项目",
        "score3": "\"现状\"项目",
        "score5": "基础项目",
        "score8": "概念项目",
        "score10": "无项目文档"
      },
      "psbK": {
        "score0": "设有行政单位并配备负责大坝安全的合格技术专业人员",
        "score1": "配备负责大坝安全的合格技术专业人员（自有或外包）",
        "score3": "设有行政单位但无负责大坝安全的合格技术专业人员",
        "score6": "既无行政单位也无负责大坝安全的合格技术负责人"
      },
      "psbL": {
        "score0": "拥有检查、监测和运行程序手册",
        "score2": "仅拥有监测程序手册",
        "score4": "仅拥有检查程序手册",
        "score8": "没有用于监测和检查的正式手册或程序"
      },
      "psbM": {
        "score0": "拥有 PAE",
        "score2": "无 PAE（监管机构未要求）",
        "score4": "PAE 正在编制",
        "score8": "无 PAE（监管机构要求时）"
      },
      "psbN": {
        "score0": "定期出具基于仪器和安全审计的检查与监测报告",
        "score2": "仅定期出具安全审计报告",
        "score4": "仅定期出具检查与监测报告",
        "score6": "仅定期出具目视检查报告",
        "score8": "不定期出具检查与监测报告及安全审计"
      },
      "pdaA": {
        "score1": "极小：≤ 100 万 m³",
        "score2": "小：100 万至 500 万 m³",
        "score3": "中：500 万至 2500 万 m³",
        "score4": "大：2500 万至 5000 万 m³",
        "score5": "极大：≥ 5000 万 m³"
      },
      "pdaB": {
        "score0": "不存在 — 大坝下游受影响区域内无常住/居住或临时/通行人员",
        "score3": "不频繁 — 无人员永久占用大坝下游受影响区域，但有地方乡道",
        "score5": "频繁 — 无人员永久占用大坝下游受影响区域，但有市政、州或联邦公路或其他场所及/或人员偶尔逗留的开发项目，可能受影响",
        "score10": "存在 — 有人员永久占用大坝下游受影响区域，因此可能危及人的生命"
      },
      "pdaC": {
        "score0": "微不足道 — 大坝下游受影响区域已完全丧失自然特征，且结构仅按 ABNT NBR 10.004 储存 II 类废物",
        "score2": "轻微显著 — 大坝下游受影响区域无相关环境利益区或受专门立法保护的区域（不含 APP），且仅按 ABNT NBR 10.004 储存 II 类废物",
        "score4": "显著 — 大坝下游受影响区域存在相关环境利益区或受专门立法保护的区域（不含 APP），且仅按 ABNT NBR 10.004 储存 II 类废物",
        "score10": "非常显著 — 大坝储存按 ABNT NBR 10.004 归类为 I 类（危险）的尾矿或固体废物"
      },
      "pdaD": {
        "score0": "不存在 — 大坝下游受影响区域内无任何设施",
        "score1": "低 — 大坝下游受影响区域内存在少量具有社会经济文化意义的居住、农业、工业设施或基础设施",
        "score3": "中 — 大坝下游受影响区域内存在中等数量具有社会经济文化意义的居住、农业、工业设施或基础设施",
        "score5": "高 — 大坝下游受影响区域内存在大量具有社会经济文化意义的居住、农业、工业设施或基础设施"
      }
    }
  },
  "mgMining": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - 风险分类" },
      "pda": { "label": "PDA", "subtitle": "2 - 潜在环境损害" }
    },
    "grades": {
      "ct": "1.1 - 技术特性 - CT",
      "ec": "1.2 - 保养状态 - EC",
      "psb": "1.3 - 大坝安全计划 - PSB",
      "pda": "2 - 按潜在环境损害分类 - PDA"
    },
    "columns": {
      "ctA": "高度",
      "ctB": "长度",
      "ctC": "设计流量",
      "ctD": "施工方法",
      "ctE": "监测仪器",
      "ecF": "溢洪结构可靠性",
      "ecG": "渗流",
      "ecH": "变形与沉降",
      "ecI": "坡面/护面的劣化",
      "psbJ": "项目文档",
      "psbK": "大坝安全团队专业人员的组织结构与资质",
      "psbL": "安全检查与监测程序手册",
      "psbM": "应急行动计划 – PAE（监管机构要求时）",
      "psbN": "仪器检查与监测报告及安全分析",
      "pdaA": "水库总库容",
      "pdaB": "下游是否存在人口",
      "pdaC": "环境影响",
      "pdaD": "社会经济影响"
    },
    "options": {
      "ctA": {
        "score0": "高度 ≤ 10m",
        "score1": "10m < 高度 < 30m",
        "score4": "30m ≤ 高度 ≤ 60m",
        "score7": "高度 > 60m"
      },
      "ctB": {
        "score0": "长度 ≤ 50m",
        "score1": "50m < 长度 < 200m",
        "score2": "200 ≤ 长度 ≤ 600m",
        "score3": "长度 > 600m"
      },
      "ctC": {
        "score0": "可能最大洪水（CMP）或万年一遇",
        "score2": "千年一遇",
        "score5": "重现期 = 500 年",
        "score10": "重现期低于 500 年或未知 / 研究不可靠"
      },
      "ctD": {
        "score0": "单一阶段",
        "score2": "下游式加高",
        "score5": "中心线式加高",
        "score10": "上游式加高或未知，或在结构生命周期内已进行过上游式加高"
      },
      "ctE": {
        "score0": "存在符合技术项目的仪器",
        "score2": "存在与项目不符的仪器，但正在安装仪器以符合项目要求",
        "score6": "存在与项目不符的仪器，且未安装仪器以符合项目要求",
        "score8": "大坝未安装仪器，与项目不符"
      },
      "ecF": {
        "score0": "土建结构保养良好且正常运行 / 大坝无需溢洪结构",
        "score3": "结构存在已识别问题且正在实施纠正措施",
        "score6": "结构存在已识别问题且未实施必要的纠正措施",
        "score10": "结构存在已识别问题，溢洪能力下降且无纠正措施"
      },
      "ecG": {
        "score0": "渗流由排水系统完全控制",
        "score3": "下游区域、护面、坡面和坝肩出现潮湿或渗水，但稳定且受监测",
        "score6": "下游区域、护面、坡面或坝肩出现潮湿或渗水，未实施必要的纠正措施",
        "score10": "下游区域出现渗水并带出材料或流量增大或所含材料发生渗透，可能危及结构安全"
      },
      "ecH": {
        "score0": "不存在可能危及结构安全的变形与沉降",
        "score2": "存在裂缝和沉陷，正在实施纠正措施",
        "score6": "存在裂缝和沉陷，未实施必要的纠正措施",
        "score10": "存在裂缝、沉陷或滑动，可能危及结构安全"
      },
      "ecI": {
        "score0": "坡面与护面无劣化",
        "score2": "坡面与护面防护失效，存在灌木植被",
        "score6": "表面侵蚀、钢筋外露、存在乔木植被，未实施必要的纠正措施",
        "score10": "坡面出现明显凹陷、滑动、深侵蚀沟，可能危及结构安全"
      },
      "psbJ": {
        "score0": "施工图项目及\"竣工\"项目",
        "score2": "施工图项目或\"竣工\"项目",
        "score3": "\"现状\"项目",
        "score5": "基础项目",
        "score8": "概念项目",
        "score10": "无项目文档"
      },
      "psbK": {
        "score0": "设有行政单位并配备负责大坝安全的合格技术专业人员",
        "score1": "配备负责大坝安全的合格技术专业人员（自有或外包）",
        "score3": "设有行政单位但无负责大坝安全的合格技术专业人员",
        "score6": "既无行政单位也无负责大坝安全的合格技术负责人"
      },
      "psbL": {
        "score0": "拥有检查、监测和运行程序手册",
        "score2": "仅拥有监测程序手册",
        "score4": "仅拥有检查程序手册",
        "score8": "没有用于监测和检查的正式手册或程序"
      },
      "psbM": {
        "score0": "拥有 PAE",
        "score2": "无 PAE（监管机构未要求）",
        "score4": "PAE 正在编制",
        "score8": "无 PAE（监管机构要求时）"
      },
      "psbN": {
        "score0": "定期出具基于仪器和安全分析的检查与监测报告",
        "score2": "仅定期出具安全分析报告",
        "score4": "仅定期出具检查与监测报告",
        "score6": "仅定期出具目视检查报告",
        "score8": "不定期出具检查与监测报告及安全分析"
      },
      "pdaA": {
        "score1": "极小：≤ 100 万 m³",
        "score2": "小：100 万至 500 万 m³",
        "score3": "中：500 万至 2500 万 m³",
        "score4": "大：2500 万至 5000 万 m³",
        "score5": "极大：≥ 5000 万 m³"
      },
      "pdaB": {
        "score0": "不存在 — 大坝下游受影响区域内无常住/居住或临时/通行人员",
        "score3": "不频繁 — 无人员永久占用大坝下游受影响区域，但有地方乡道",
        "score5": "频繁 — 无人员永久占用大坝下游受影响区域，但有市政、州或联邦公路或其他场所及/或人员偶尔逗留的开发项目，可能受影响",
        "score10": "存在 — 有人员永久占用大坝下游受影响区域，因此可能危及人的生命"
      },
      "pdaC": {
        "score0": "微不足道 — 大坝下游受影响区域已完全丧失自然特征，且结构仅按 ABNT NBR 10.004 储存 II B 类（惰性）废物",
        "score2": "轻微显著 — 大坝下游受影响区域无相关环境利益区或受专门立法保护的区域（不含 APP），且仅按 ABNT NBR 10.004 储存 II B 类（惰性）废物",
        "score6": "显著 — 大坝下游受影响区域存在相关环境利益区或受专门立法保护的区域（不含 APP），且仅按 ABNT NBR 10.004 储存 II B 类（惰性）废物",
        "score8": "非常显著 — 大坝储存按 ABNT NBR 10.004 归类为 II A 类（非惰性）的尾矿或固体废物",
        "score10": "非常显著加重 — 大坝储存按 ABNT NBR 10.004 归类为 I 类（危险）的尾矿或固体废物"
      },
      "pdaD": {
        "score0": "不存在 — 大坝下游受影响区域内无任何设施",
        "score1": "低 — 大坝下游受影响区域内存在少量具有社会经济文化意义的居住、农业、工业设施或基础设施",
        "score3": "中 — 大坝下游受影响区域内存在中等数量具有社会经济文化意义的居住、农业、工业设施或基础设施",
        "score5": "高 — 大坝下游受影响区域内存在大量具有社会经济文化意义的居住、农业、工业设施或基础设施"
      }
    }
  },
  "mgWater": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - 风险分类" },
      "pda": { "label": "PDA", "subtitle": "2 - 潜在环境损害" }
    },
    "grades": {
      "ct": "1.1 - 技术特性 - CT",
      "ec": "1.2 - 保养状态 - EC",
      "psb": "1.3 - 大坝安全计划 - PSB",
      "pda": "2 - 按潜在环境损害分类 - PDA"
    },
    "columns": {
      "ctA": "高度",
      "ctB": "长度",
      "ctC": "按建筑材料划分的大坝类型",
      "ctD": "基础类型",
      "ctE": "大坝年龄",
      "ctF": "设计流量",
      "ecG": "溢洪结构可靠性",
      "ecH": "引水结构可靠性",
      "ecI": "渗流",
      "ecJ": "变形与沉降",
      "ecK": "坡面/护面的劣化",
      "psbL": "项目文档的存在",
      "psbM": "大坝安全团队专业人员的组织结构与技术资质",
      "psbN": "安全检查与监测的例行程序",
      "psbO": "大坝排放装置的运行规则",
      "psbP": "带分析与解释的安全检查报告",
      "pdaA": "水库总库容",
      "pdaB": "人命损失潜势",
      "pdaC": "环境影响",
      "pdaD": "社会经济影响"
    },
    "options": {
      "ctA": {
        "score0": "高度 ≤ 10m",
        "score1": "10m < 高度 < 30m",
        "score2": "30m ≤ 高度 ≤ 60m",
        "score3": "高度 > 60m"
      },
      "ctB": {
        "score2": "长度 ≤ 200m",
        "score3": "长度 > 200m"
      },
      "ctC": {
        "score1": "常规混凝土",
        "score2": "块石砌体 / 浆砌块石混凝土 / 碾压混凝土 – CCR",
        "score3": "均质土 / 堆石 / 土石坝"
      },
      "ctD": {
        "score1": "完整岩石",
        "score2": "经处理的硬质风化岩",
        "score3": "未经处理的风化岩 / 经处理的破碎风化岩",
        "score4": "软质风化岩 / 腐泥岩 / 密实土",
        "score5": "残积土 / 冲积土"
      },
      "ctE": {
        "score1": "30 至 50 年之间",
        "score2": "10 至 30 年之间",
        "score3": "5 至 10 年之间",
        "score4": "< 5 年或 > 50 年或无信息"
      },
      "ctF": {
        "score3": "可能最大洪水（CMP）或万年一遇",
        "score5": "千年一遇",
        "score8": "重现期 = 500 年",
        "score10": "重现期 < 500 年或未知 / 研究不可靠"
      },
      "ecG": {
        "score0": "土建与水力机电结构全面运行 / 进水或退水渠道或溢洪道（自由溢流堰型）畅通无阻",
        "score4": "土建与水力机电结构已为运行做好准备，但无应急供电源 / 渠道或溢洪道（自由溢流堰型）存在侵蚀或堵塞，但不危及溢洪结构",
        "score7": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且正在实施纠正措施 / 渠道或溢洪道（自由溢流堰型）存在侵蚀及/或部分堵塞，有危及溢洪结构的风险",
        "score10": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且无纠正措施 / 渠道或溢洪道（自由溢流堰型）堵塞或结构受损"
      },
      "ecH": {
        "score0": "土建结构与水力机电装置处于适当的维护和运行状态",
        "score4": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且正在实施纠正措施",
        "score6": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且无纠正措施"
      },
      "ecI": {
        "score0": "渗流由排水系统完全控制",
        "score3": "下游区域、护面、坡面或坝肩出现潮湿或渗水，但已稳定及/或受监测",
        "score5": "下游区域、护面、坡面或坝肩出现潮湿或渗水，未处理或处于诊断阶段",
        "score8": "下游区域、坡面或坝肩出现渗水并带出材料或流量增大"
      },
      "ecJ": {
        "score0": "不存在",
        "score1": "存在小范围、无影响的裂缝和沉陷",
        "score5": "存在影响较大的裂缝和沉陷，需进行额外研究或监测",
        "score8": "存在明显的裂缝、沉陷或滑动，可能危及安全"
      },
      "ecK": {
        "score0": "不存在",
        "score1": "坡面与护面防护失效，存在小范围、无影响的灌木",
        "score5": "表面侵蚀、钢筋外露、植被普遍生长，需进行监测或纠正措施",
        "score7": "坡面出现明显凹陷、滑动、深侵蚀沟，可能危及安全"
      },
      "psbL": {
        "score0": "施工图项目及\"竣工\"项目",
        "score2": "施工图项目或\"竣工\"项目",
        "score4": "基础项目",
        "score6": "初步设计或概念项目",
        "score8": "无项目文档"
      },
      "psbM": {
        "score0": "设有组织结构并配备负责大坝安全的技术人员",
        "score4": "配备负责大坝安全的技术人员",
        "score8": "既无组织结构也无负责大坝安全的技术负责人"
      },
      "psbN": {
        "score0": "拥有并执行检查与监测程序",
        "score3": "拥有并仅执行检查程序",
        "score5": "拥有但不执行检查与监测程序",
        "score6": "既无也不执行监测和检查程序"
      },
      "psbO": {
        "score0": "是，或自由溢流堰型溢洪道",
        "score6": "否"
      },
      "psbP": {
        "score0": "定期出具报告",
        "score3": "不定期出具报告",
        "score5": "不出具报告"
      },
      "pdaA": {
        "score0": "极小：≤ 100 万 m³",
        "score1": "小：100 万至 500 万 m³",
        "score2": "中：500 万至 2500 万 m³",
        "score3": "大：2500 万至 5000 万 m³",
        "score4": "极大：≥ 5000 万 m³"
      },
      "pdaB": {
        "score0": "不存在 — 大坝下游受影响区域内无常住/居住或临时/通行人员",
        "score4": "不频繁 — 无人员永久占用大坝下游受影响区域，但有地方乡道",
        "score8": "频繁 — 无人员永久占用大坝下游受影响区域，但有市政、州或联邦公路或其他场所及/或人员偶尔逗留的开发项目，可能受影响",
        "score12": "存在 — 有人员永久占用大坝下游受影响区域，因此可能危及人的生命"
      },
      "pdaC": {
        "score1": "轻微显著 — 大坝受影响区域不属于环境利益区、受专门立法保护的区域，或已完全丧失自然特征",
        "score2": "显著 — 受影响区域包含可持续利用保护区（APA、FLONA、RESEX 等），或属于环境利益区且自然特征略有丧失",
        "score5": "非常显著 — 受影响区域包含完全保护区（ESEC、PARNA、REBIO 等，含原住民土地），或处于自然状态且具有重大环境利益"
      },
      "pdaD": {
        "score0": "不存在 — 大坝事故受影响区域内无任何设施和通航服务",
        "score1": "低 — 大坝受影响区域内存在 1 至 5 处居住和商业、农业、工业设施或基础设施",
        "score3": "中 — 大坝受影响区域内存在 5 至 30 处居住和商业、农业、工业设施或基础设施",
        "score8": "高 — 大坝受影响区域内存在大量居住和商业、农业、工业设施、基础设施及休闲旅游服务，或港口设施或通航服务"
      }
    }
  },
  "igam": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - 风险分类" },
      "dpa": { "label": "DPA", "subtitle": "2 - 关联潜在损害" }
    },
    "grades": {
      "ct": "1.1 - 技术特性 - CT",
      "ec": "1.2 - 保养状态 - EC",
      "psb": "1.3 - 大坝安全计划 - PS",
      "dpa": "2 - 按关联潜在损害分类 - DPA"
    },
    "columns": {
      "ctA": "高度",
      "ctB": "长度",
      "ctC": "按建筑材料划分的大坝类型",
      "ctD": "基础类型",
      "ctE": "大坝年龄",
      "ctF": "设计流量",
      "ecG": "溢洪结构可靠性",
      "ecH": "引水结构可靠性",
      "ecI": "渗流",
      "ecJ": "变形与沉降",
      "ecK": "坡面/护面的劣化",
      "ecL": "船闸",
      "psbM": "项目文档的存在",
      "psbN": "大坝安全团队专业人员的组织结构与技术资质",
      "psbO": "安全检查与监测的例行程序",
      "psbP": "大坝排放装置的运行规则",
      "psbQ": "带分析与解释的安全检查报告",
      "dpaA": "水库总库容",
      "dpaB": "人命损失潜势",
      "dpaC": "环境影响",
      "dpaD": "社会经济影响"
    },
    "options": {
      "ctA": {
        "score0": "高度 ≤ 15m",
        "score1": "15m < 高度 < 30m",
        "score2": "30m ≤ 高度 ≤ 60m",
        "score3": "高度 > 60m"
      },
      "ctB": {
        "score2": "长度 ≤ 200m",
        "score3": "长度 > 200m"
      },
      "ctC": {
        "score1": "常规混凝土",
        "score2": "块石砌体 / 浆砌块石混凝土 / 碾压混凝土 – CCR",
        "score3": "均质土 / 堆石 / 土石坝"
      },
      "ctD": {
        "score1": "完整岩石",
        "score2": "经处理的硬质风化岩",
        "score3": "未经处理的风化岩 / 经处理的破碎风化岩",
        "score4": "软质风化岩 / 腐泥岩 / 密实土",
        "score5": "残积土 / 冲积土"
      },
      "ctE": {
        "score1": "30 至 50 年之间",
        "score2": "10 至 30 年之间",
        "score3": "5 至 10 年之间",
        "score4": "< 5 年或 > 50 年或无信息"
      },
      "ctF": {
        "score3": "可能最大洪水（CMP）或万年一遇",
        "score5": "千年一遇",
        "score8": "重现期 = 500 年",
        "score10": "重现期 < 500 年或未知 / 研究不可靠"
      },
      "ecG": {
        "score0": "土建与水力机电结构全面运行 / 进水或退水渠道或溢洪道（自由溢流堰型）畅通无阻",
        "score4": "土建与水力机电结构已为运行做好准备，但无应急供电源 / 渠道或溢洪道（自由溢流堰型）存在侵蚀或堵塞，但不危及溢洪结构",
        "score7": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且正在实施纠正措施 / 渠道或溢洪道（自由溢流堰型）存在侵蚀及/或部分堵塞，有危及溢洪结构的风险",
        "score10": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且无纠正措施 / 渠道或溢洪道（自由溢流堰型）堵塞或结构受损"
      },
      "ecH": {
        "score0": "土建结构与水力机电装置处于适当的维护和运行状态",
        "score4": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且正在实施纠正措施",
        "score6": "土建结构受损或水力机电装置存在已识别问题，过流能力下降且无纠正措施"
      },
      "ecI": {
        "score0": "渗流由排水系统完全控制",
        "score3": "下游区域、护面、坡面或坝肩出现潮湿或渗水，但已稳定及/或受监测",
        "score5": "下游区域、护面、坡面或坝肩出现潮湿或渗水，未处理或处于诊断阶段",
        "score8": "下游区域、坡面或坝肩出现渗水并带出材料或流量增大"
      },
      "ecJ": {
        "score0": "不存在",
        "score1": "存在小范围、无影响的裂缝和沉陷",
        "score5": "存在影响较大的裂缝和沉陷，需进行额外研究或监测",
        "score8": "存在明显的裂缝、沉陷或滑动，可能危及安全"
      },
      "ecK": {
        "score0": "不存在",
        "score1": "坡面与护面防护失效，存在小范围、无影响的灌木",
        "score5": "表面侵蚀、钢筋外露、植被普遍生长，需进行监测或纠正措施",
        "score7": "坡面出现明显凹陷、滑动、深侵蚀沟，可能危及安全"
      },
      "ecL": {
        "score0": "无船闸",
        "score1": "土建与水力机电结构保养良好且正常运行",
        "score2": "土建结构受损或水力机电装置存在已识别问题且正在实施纠正措施",
        "score4": "土建结构受损或水力机电装置存在已识别问题且无纠正措施"
      },
      "psbM": {
        "score0": "施工图项目及\"竣工\"项目",
        "score2": "施工图项目或\"竣工\"项目",
        "score4": "基础项目",
        "score6": "初步设计或概念项目",
        "score8": "无项目文档"
      },
      "psbN": {
        "score0": "设有组织结构并配备负责大坝安全的技术人员",
        "score4": "配备负责大坝安全的技术人员",
        "score8": "既无组织结构也无负责大坝安全的技术负责人"
      },
      "psbO": {
        "score0": "拥有并执行检查与监测程序",
        "score3": "拥有并仅执行检查程序",
        "score5": "拥有但不执行检查与监测程序",
        "score6": "既无也不执行监测和检查程序"
      },
      "psbP": {
        "score0": "是，或自由溢流堰型溢洪道",
        "score6": "否"
      },
      "psbQ": {
        "score0": "定期出具报告",
        "score3": "不定期出具报告",
        "score5": "不出具报告"
      },
      "dpaA": {
        "score1": "小：≤ 500 万 m³",
        "score2": "中：500 万至 7500 万 m³",
        "score3": "大：7500 万至 2 亿 m³",
        "score5": "极大：> 2 亿 m³"
      },
      "dpaB": {
        "score0": "不存在 — 大坝下游受影响区域内无常住/居住或临时/通行人员",
        "score4": "不频繁 — 无人员永久占用大坝下游受影响区域，但有地方乡道",
        "score8": "频繁 — 无人员永久占用大坝下游受影响区域，但有市政、州或联邦公路或其他场所及/或人员偶尔逗留的开发项目，可能受影响",
        "score12": "存在 — 有人员永久占用大坝下游受影响区域，因此可能危及人的生命"
      },
      "dpaC": {
        "score1": "轻微显著 — 大坝受影响区域不属于环境利益区、受专门立法保护的区域，或已完全丧失自然特征",
        "score2": "显著 — 受影响区域包含可持续利用保护区（APA、FLONA、RESEX 等），或属于环境利益区且自然特征略有丧失",
        "score5": "非常显著 — 受影响区域包含完全保护区（ESEC、PARNA、REBIO 等，含原住民土地），或处于自然状态且具有重大环境利益"
      },
      "dpaD": {
        "score0": "不存在 — 大坝事故受影响区域内无任何设施和通航服务",
        "score1": "低 — 大坝受影响区域内存在居住和商业、农业、工业设施或基础设施",
        "score3": "中 — 大坝受影响区域内存在居住、农业、工业设施或基础设施",
        "score8": "高 — 大坝受影响区域内存在大量居住、农业设施、基础设施及休闲旅游服务，或港口设施或通航服务"
      }
    }
  }
} as const;
